<script setup>
const models = [
  {
    badge: 'models.items.0.model',
    title: 'models.title',
    text: 'models.items.0.text',
    image: '/images/section/models/model-1.png',
  },
  {
    badge: 'models.items.1.model',
    text: 'models.items.1.text',
    image: '/images/section/models/model-2.png',
  },
];
</script>

<template>
  <section class="section-models">
    <div class="container">
      <div class="section-models__cards">
        <CardModel
          v-for="(model, index) in models"
          :key="index"
          :image="model.image"
          :badge="$t(model.badge)"
          :text="$t(model.text)"
          :title="model.title && $t(model.title)"
        />
      </div>
    </div>
  </section>
</template>

<style scoped lang="scss">
.section-models {
  &__cards {
    @include media-breakpoint-desktop {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: em(32);
    }
  }
}
</style>
